export const majorProjects = [
  {
    name: "Artistify Community Platform",
    description:
      "A platform designed for leading digital artists around the globe to showcase their work and create an online presence for their brand. Create your portfolio, demonstrate your talent to recruiters and pave the way ahead for your bright career as an artist.",
    githubLink: "https://github.com/Kawaljeet2001/Artistify-Community-Platform",
    liveLink: "https://artistifycommunity.netlify.app/",
    demoLink: "https://youtu.be/E302nz_ihtA",
    imgLink:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-b8622.appspot.com/o/ii2.png?alt=media&token=33026fca-adcf-40be-b6a1-a3844065a948",
    tools: [
      "React.js",
      "Redux",
      "MongoDB Atlas",
      "Node.js",
      "Express.js",
      "Tailwind CSS",
      "Nodemailer",
      "Firebase",
      "JWT",
      "Heroku",
    ],
  },
  {
    name: "Content Based Movie Recommendation System",
    description:
      "This is the Movie Recommendation System project using a Content-Based recommender system trained on more than 5000 movies for generating movie recommendations based on user search.",
    githubLink: "https://github.com/Kawaljeet2001/Movie-Recommendation-System",
    liveLink: "https://movierecsys-ksb.herokuapp.com/",
    demoLink: "",
    imgLink:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-b8622.appspot.com/o/4.png?alt=media&token=286f0192-7a63-4e73-a7fa-4a0203209658",
    tools: [
      "React.js",
      "Flask",
      "Tmdb API",
      "CSS",
      "Scikit Learn",
      "Count Vectorizer",
      "Numpy",
      "Pandas",
      "Heroku",
    ],
  },
  {
    name: "Data Encryption using Image Steganographic methods",
    description:
      "The project discusses about existing and novel approaches of using Image Steganography to encrypt and share data. The principle is to hide sensitive data in carrier images and transmit those images over communication channel.",
    githubLink:
      "https://github.com/Kawaljeet2001/Date-Encryption-by-Image-Steganography",
    liveLink: "",
    demoLink: "",
    imgLink:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-b8622.appspot.com/o/Screenshot%20(2846).png?alt=media&token=8faceabb-2e9f-45f1-9ef8-e7afcecfd9b7",
    tools: [
      "React.js",
      "Python",
      "Flask",
      "Pillow",
      "Javasscript",
      "Tailwind CSS",
      "Firebase",
    ],
  },
];
